export default "__VITE_ASSET__BlVdBbtA__"